import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SpreadProfileAction } from '../spreadProfile.action';

type IDependencies = IClientApiDependencySegment;

export const loadSpreadProfileListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SpreadProfileAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getSpreadProfileList().pipe(
      mergeMap((response) => {
        return [
          SpreadProfileAction.loadList.done({ result: response.spreadProfiles }),
        ];
      }),
      catchApiError((error) => {
        return [
          SpreadProfileAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
